import React from "react";
import { Grid } from "@mui/material";

const FeaturesCard = (props) => {
    return(
        <Grid
            xs={12}
            className="EP---feactres-cards px-3 py-2"
        >   
            <div className="px-5 py-5">
                <img src={props.img} className="img-fluid" />
                <h4 className="mb-2 mt-3">{props.title}</h4>
                <p className="mb-0">{props.subtitle}</p>
            </div>
        </Grid>
    )
}

export default FeaturesCard;